/**
 * Taken from Mantine https://mantine.dev/
 * https://github.com/mantinedev/mantine/blob/master/src/mantine-utils/src/create-safe-context/create-safe-context.tsx
 */
import React, { createContext, useContext } from "react";

export function createSafeContext<ContextValue>(errorMessage: string) {
	const Context = createContext<ContextValue | null>(null);

	const useSafeContext = () => {
		const ctx = useContext(Context);

		if (ctx === null) {
			throw new Error(errorMessage);
		}

		return ctx;
	};

	const Provider = ({ children, value }: { value: ContextValue; children: React.ReactNode }) => (
		<Context.Provider value={value}>{children}</Context.Provider>
	);

	return [useSafeContext, Provider] as const;
}
